var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 8.93203V10.932C11.3335 13.5987 10.2668 14.6654 7.60016 14.6654H5.06683C2.40016 14.6654 1.3335 13.5987 1.3335 10.932V8.3987C1.3335 5.73203 2.40016 4.66536 5.06683 4.66536H7.06683M11.3335 8.93203H9.20016C7.60016 8.93203 7.06683 8.3987 7.06683 6.7987V4.66536M11.3335 8.93203L7.06683 4.66536M7.7335 1.33203H10.4002M4.66683 3.33203C4.66683 2.22536 5.56016 1.33203 6.66683 1.33203H8.4135M14.6668 5.33203V9.4587C14.6668 10.492 13.8268 11.332 12.7935 11.332M14.6668 5.33203H12.6668C11.1668 5.33203 10.6668 4.83203 10.6668 3.33203V1.33203L14.6668 5.33203Z",
    stroke: "#149CCE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButton);
export default __webpack_public_path__ + "static/media/copyButton.92f9de05a36254fe5658423ccc2b3f60.svg";
export { ForwardRef as ReactComponent };